import { IonAlert } from "@ionic/react";
import { LocalStorage, continueLogoutFromICAgreementPopup } from "@store/session";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { useSession } from "../store/helperHooks";

import "./style.scss";

const SignICAgreementModal = () => {
  const dispatch = useDispatch();

  const [workerConfirmedToLogOut, setWorkerConfirmedToLogOut] = useState(false);
  const { popups, isAuthorized } = useSession();

  const { visible: shouldShowICAgreementPopup = false } = popups?.ICAgreement ?? {};

  const onContinue = async () => {
    dispatch(continueLogoutFromICAgreementPopup());
    setWorkerConfirmedToLogOut(true);
  };

  useEffect(() => {
    if (!workerConfirmedToLogOut || isAuthorized) {
      return;
    }
    localStorage.setItem(LocalStorage.WAS_LOGGED_OUT_FOR_NEW_IC_AGREEMENT, "true");
    setWorkerConfirmedToLogOut(false);
  }, [workerConfirmedToLogOut, isAuthorized]);

  return (
    <>
      {shouldShowICAgreementPopup && (
        <IonAlert
          isOpen={true}
          header="We've updated our Independent Contractor Agreement"
          message="Please log back in to review and accept our updated Independent Contractor agreement, which governs your access to Clipboard's technology platform and applications."
          cssClass="sign-ic-agreement-popup"
          mode="ios"
          backdropDismiss={false}
          keyboardClose={true}
          buttons={[
            {
              text: "Continue",
              cssClass: "review-and-sign",
              handler: onContinue,
            },
          ]}
        />
      )}
    </>
  );
};

export { SignICAgreementModal };
